(function () {
  let addButtons = document.querySelectorAll('.js-add-budget');
  addButtons.forEach(function (addButton) {
    addButton.addEventListener('click', function (event) {
      const originalForm = this.closest('.js-budget-group');
      let total = originalForm.querySelector(
        'input[type="hidden"][name*="TOTAL_FORMS"]'
      );
      const totalNameAttribute = total.getAttribute('name');
      let totalNameSubstring = totalNameAttribute.substring(
        0,
        totalNameAttribute.indexOf('formset-TOTAL_FORMS')
      );
      const budgetItems = originalForm.querySelectorAll('.js-budget-item');
      let clonedSection;
      if (budgetItems.length === 0) {
        // Create the desired HTML structure
        clonedSection = document.createElement('div');
        clonedSection.className = 'budget-item js-budget-item';

        clonedSection.innerHTML = `
          <input type="hidden" name="funding_formset-0-funding_type" value="Funding" id="id_funding_formset-0-funding_type">

          <fieldset class="small-label">
            <div class="fieldWrapper form-control">
              <div class="fieldInputWrapper custom-disabled-field">
                <label class="label" for="id_funding_formset-0-name">Budget item title</label>
                <input type="text" required="true" id="id_funding_formset-0-name" name="funding_formset-0-name" readonly class="form-control" value="Other">
              </div>
              <div class="fieldErrorWrapper"></div>
            </div>
            <legend class="mg-b-m label">New budget item</legend>
            <button type="button" class="btn-delete js-delete-budget"><span class="sr-only">remove Event management/planning</span></button>

            <div class="fieldWrapper form-control fieldWrapper_budget_amount">
              <div class="fieldInputWrapper">
                <label for="id_funding_formset-0-budget_amount">Budget</label>
                <input type="number" name="funding_formset-0-budget_amount" class="form-control" required="true" placeholder="Enter Budget" step="any" id="id_funding_formset-0-budget_amount">
              </div>
              <div class="fieldErrorWrapper"></div>
            </div>

            <div class="fieldWrapper form-control fieldWrapper_description">
              <div class="fieldInputWrapper">
                <label for="id_funding_formset-0-description">Description (Please provide a description of the budget item)</label>
                <textarea name="funding_formset-0-description" cols="40" rows="3" class="form-control" required="true" placeholder="Add description here" id="id_funding_formset-0-description"></textarea>
              </div>
              <div class="fieldErrorWrapper"></div>
            </div>
          </fieldset>
        `;
      } else {
        // Clone the last budget item
        clonedSection = budgetItems[budgetItems.length - 1].cloneNode(true);
        clonedSection.hidden = false;
      }

      let originalFieldId, originalFieldName;

      clonedSection
        .querySelectorAll('input:not([type=hidden]), textarea, select')
        .forEach(function (input) {
          input.value = '';
          const parent = input.closest('.fieldWrapper');
          const child = parent.querySelector('.fieldErrorWrapper');
          const label = parent.querySelector('label');
          child.classList.remove('error');
          child.innerHTML = '';
          originalFieldId = input.getAttribute('id');
          originalFieldName = input.getAttribute('name');
          if (originalFieldId && originalFieldName) {
            let fieldCount;
            if (budgetItems.length === 0) {
              fieldCount = 0;
            } else {
              fieldCount = parseInt(originalFieldId.match(/\d+/)[0]) + 1;
            }
            const newId = originalFieldId.replace(/\d+/, fieldCount);
            const newName = originalFieldName.replace(/\d+/, fieldCount);
            let updatedNewId = newId.replace(
              /.*(?=formset)/,
              totalNameSubstring
            );
            let updatedNewName = newName.replace(
              /.*(?=formset)/,
              totalNameSubstring
            );
            input.setAttribute('id', updatedNewId);
            input.setAttribute('name', updatedNewName);
            label.setAttribute('for', updatedNewId);
          }
        });
      clonedSection
        .querySelectorAll('input[type=hidden]')
        .forEach(function (input) {
          originalFieldId = input.getAttribute('id');
          originalFieldName = input.getAttribute('name');
          if (originalFieldName) {
            // Check if the field should be deleted
            const shouldDelete =
              originalFieldName.endsWith('id') ||
              originalFieldName.endsWith('cap_budget') ||
              originalFieldName.endsWith('DELETE') ||
              originalFieldName.endsWith('name');

            if (shouldDelete) {
              input.remove(); // Remove the input element
            } else {
              let fieldCount = parseInt(originalFieldId.match(/\d+/)[0]) + 1;
              if (budgetItems.length === 0) {
                fieldCount = 0;
              }
              const newId = originalFieldId.replace(/\d+/, fieldCount);
              const newName = originalFieldName.replace(/\d+/, fieldCount);
              let updatedNewId = newId.replace(
                /.*(?=formset)/,
                totalNameSubstring
              );
              let updatedNewName = newName.replace(
                /.*(?=formset)/,
                totalNameSubstring
              );
              input.setAttribute('id', updatedNewId);
              input.setAttribute('name', updatedNewName);
            }
          }
        });

      const fundingType = clonedSection.querySelector(
        'input[type="hidden"][name*="funding_type"]'
      );

      if (totalNameSubstring.slice(-1) === '_') {
        totalNameSubstring = totalNameSubstring.slice(0, -1);
      }

      if (totalNameSubstring.includes('contribution')) {
        fundingType.value = 'Kind Contribution';
      } else if (totalNameSubstring.includes('other')) {
        fundingType.value = 'Others';
      } else {
        fundingType.value =
          totalNameSubstring.charAt(0).toUpperCase() +
          totalNameSubstring.slice(1);
      }

      let hasTextInputWithName = Array.from(
        clonedSection.querySelectorAll('input[type="text"]')
      ).some(input => input.name.endsWith('name'));
      if (!hasTextInputWithName) {
        const newField = document.createElement('div');
        let fieldCount = parseInt(originalFieldId.match(/\d+/)[0]) + 1;
        let newFieldId = originalFieldId.replace(
          /\d+.*$/,
          fieldCount + '-name'
        );
        let newFieldName = originalFieldName.replace(
          /\d+.*$/,
          fieldCount + '-name'
        );

        let newFieldTitle = 'Budget item title';

        newField.className = 'fieldWrapper form-control';
        newField.innerHTML = `
          <div class="fieldInputWrapper custom-disabled-field">
            <label class="label" for="${newFieldId}">${newFieldTitle}</label>
            <input type="text" id="${newFieldId}" name="${newFieldName}" class="form-control" value="Other" readonly>
          </div>
          <div class="fieldErrorWrapper "></div>
        `;
        let formContentWrapper = clonedSection.querySelector('fieldset');
        let legend = clonedSection.querySelector('legend');
        legend.textContent = 'New budget item';
        formContentWrapper.insertBefore(
          newField,
          formContentWrapper.firstChild
        );
      }
      total.value = parseInt(total.value) + 1;

      const errorElement = clonedSection.querySelector('.error-message');
      if (errorElement) {
        errorElement.remove();
      }

      const addButton = event.target;
      addButton.parentNode.insertBefore(clonedSection, addButton);

      const budgetTitleInput =
        clonedSection.querySelector("input[type='text']");
      if (budgetTitleInput) {
        budgetTitleInput.focus();
        budgetTitleInput.value = 'Other';
      }
    });
  });
})();
